import React, { Component } from 'react';
import { Button, Modal, Form,Message } from 'semantic-ui-react';
import * as api from '../../api';

class AddVideoGuideModal extends Component {
  state = {
    modalOpen: false,
    title: '',
    description: '',
    vimeoLink: '',
    category: 'All',
  };

  setOpen = (open) => {
    this.setState({ modalOpen: open });
  };

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { title, description, vimeoLink, category } = this.state; // Include category here
    const newGuide = { title, description, vimeoLink, category };

    const formData = new FormData();
    formData.append("Title", newGuide.title);
    formData.append("Description", newGuide.description);
    formData.append("VimeoLink", newGuide.vimeoLink);
    formData.append("Category", category);



    api.addVideoGuide(formData) // Define this method in your api.js
      .then(() => {
        this.setOpen(false);
        // Reset the form state to its initial values
      this.setState({
        title: '',
        description: '',
        vimeoLink: '',
        category: 'All',
      });
        this.props.onNewGuide();
      })
      .catch(err => {
      });
  };

  render() {
    const { modalOpen, title, description, vimeoLink } = this.state;

    return (
      <Modal
        trigger={<Button onClick={() => this.setOpen(true)}>Add Video Guide</Button>}
        open={modalOpen}
        onClose={() => this.setOpen(false)}
      >
        <Modal.Header>Add a New Video Guide</Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleSubmit}>
            <Form.Input
              fluid
              label="Title"
              placeholder="Title"
              name="title"
              value={title}
              onChange={this.handleChange}
            />
            <Form.TextArea
              label="Description"
              placeholder="Description"
              name="description"
              value={description}
              onChange={this.handleChange}
            />
            <Form.Dropdown
      label="Category"
      placeholder="Category"
      name="category"
      selection
      options={[
        { key: 'all', text: 'All', value: 'All' },
        { key: 'std', text: 'Standard COTS', value: 'Standard COTS' },
        { key: 'hhd', text: 'Half Hourly Data', value: 'Half Hourly Data' },
        { key: 'qc', text: 'Queries and Cases', value: 'Queries and Cases' },
      ]}
      value={this.state.category}
      onChange={this.handleChange}
    />
            <Form.Input
              fluid
              label="Vimeo Link"
              placeholder="Vimeo Link"
              name="vimeoLink"
              value={vimeoLink}
              onChange={this.handleChange}
            />
            <Message info>
    <Message.Header>Important: Vimeo Link Format Instructions</Message.Header>
    <p>To ensure your video is correctly embedded, please format your Vimeo link as follows:</p>
    <ul>
      <li>Convert your standard Vimeo link from this format: <code>https://vimeo.com/123456</code></li>
      <li>To this format for embedding: <code>https://player.vimeo.com/video/123456</code></li>
    </ul>
    <p>Note: You must also adjust your video&apos;s settings on Vimeo to allow external embedding. This is necessary for the video to be displayed on our site.</p>
  </Message>
            <Form.Button content="Submit" />
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export default AddVideoGuideModal;
